import * as yup from 'yup';

import { TrlFormattedMessagePlain } from '»utils/i18n';

export const trlChangePasswordValidation = () =>
  yup.object().shape({
    passwordAtual: yup
      .string()
      .required(TrlFormattedMessagePlain({ id: 'TRLT_UI-REQUIRED_FIELD' })),
    passwordNova: yup
      .string()
      .required(TrlFormattedMessagePlain({ id: 'TRLT_UI-REQUIRED_FIELD' })),
    passwordConfirmar: yup
      .string()
      .oneOf(
        [yup.ref('passwordNova'), ''],
        TrlFormattedMessagePlain({ id: 'TRLT_UI-PASSWORD_MATCH' }),
      )
      .required(TrlFormattedMessagePlain({ id: 'TRLT_UI-REQUIRED_FIELD' })),
  });
